module.exports = function() {
  return new Worker(__webpack_public_path__ + "6030add9235fa75dc7df.worker.js");
};